import { Reducer } from "../../lib/redux";
import { OpenCabWorkflowActions } from "./actions";
import { IOpenCabWorkflow, OpenCabWorkflowActionTypes } from "./types";

export let defaultOpenCabWorkflow: IOpenCabWorkflow = {};

export let openCabWorkflow: Reducer<IOpenCabWorkflow, OpenCabWorkflowActions> = (state = defaultOpenCabWorkflow, action) => {
    switch (action.type) {
        case OpenCabWorkflowActionTypes.SET_SKIPPED_ASSET_SELECTION:
            return { ...state, skippedAssetSelection: action.payload };
        case OpenCabWorkflowActionTypes.CLEAR_SKIPPED_ASSET_SELECTION: {
            let result = {...state};
            delete result.skippedAssetSelection;
            return result;
        }
        case OpenCabWorkflowActionTypes.SET_PRE_TRIP_DVIR_COMPLETE_VEHICLE_ID:
            return { ...state, preTripDvirCompleteVehicleId: action.payload };
        case OpenCabWorkflowActionTypes.CLEAR_PRE_TRIP_DVIR_COMPLETE_VEHICLE_ID: {
            let result = {...state};
            delete result.preTripDvirCompleteVehicleId;
            return result;
        }
        case OpenCabWorkflowActionTypes.SET_USER_SKIPPED_UNVERIFIED_LOGS_DATE:
            return { ...state, userSkippedUnverifiedLogsDate: { ...state.userSkippedUnverifiedLogsDate, ...action.payload } };
        case OpenCabWorkflowActionTypes.CLEAR_USER_SKIPPED_UNVERIFIED_LOGS_DATE: {
            let result = {...state};
            if (action.payload && result.userSkippedUnverifiedLogsDate !== undefined) {
                delete result.userSkippedUnverifiedLogsDate[action.payload];
            } else {
                delete result.userSkippedUnverifiedLogsDate;
            }
            return result;
        }
        case OpenCabWorkflowActionTypes.SET_USER_LAST_SEEN_UNCERTIFIED_HOS_NOTIFICATION_DATE:
            return { ...state, userLastSeenUncertifiedHosNotificationDate: { ...state.userLastSeenUncertifiedHosNotificationDate, ...action.payload } };
        case OpenCabWorkflowActionTypes.CLEAR_USER_LAST_SEEN_UNCERTIFIED_HOS_NOTIFICATION_DATE: {
            let result = {...state};
            if (action.payload && result.userLastSeenUncertifiedHosNotificationDate !== undefined) {
                delete result.userLastSeenUncertifiedHosNotificationDate[action.payload];
            }
            return result;
        }
        default:
            return state;
    }
};
